import React from "react";
import { Wine, UtensilsCrossed, Mic2, Music4 } from "lucide-react";

const OFFERINGS = [
  {
    icon: Wine,
    title: "Crafted Cocktails",
    body: "Creative, presentation-driven drinks designed to be part of the show.",
  },
  {
    icon: UtensilsCrossed,
    title: "Small Plates",
    body: "Rotating tapas-style bites that complement conversation and performance.",
  },
  {
    icon: Mic2,
    title: "Live Entertainment",
    body: "Close-up, energetic vocal performances that make guests part of the room.",
  },
  {
    icon: Music4,
    title: "Late Night",
    body: "DJ sets, live dancers and a dedicated dance room for high-energy evenings.",
  },
];

export default function Offerings() {
  return (
    <section id="offerings" data-testid="offerings-section" className="relative py-24 md:py-32 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">What We Offer</p>
            <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl tracking-tight">
              The full <span className="italic text-[#D4AF37]">evening</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md leading-relaxed">
            A compact, thoughtfully designed layout that brings guests close to the action — polished yet welcoming
            service that enhances the room without overpowering it.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-800">
          {OFFERINGS.map((o, i) => {
            const Icon = o.icon;
            return (
              <article
                key={o.title}
                data-testid={`offering-${i}`}
                className="group bg-neutral-950 p-8 md:p-10 hover:bg-neutral-900 transition-colors min-h-[260px] flex flex-col"
              >
                <Icon size={28} className="text-[#D4AF37]" strokeWidth={1.25} />
                <h3 className="font-serif text-2xl md:text-3xl text-white tracking-tight mt-8">{o.title}</h3>
                <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{o.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
